<template>
  <div class="content-main page-community-rules">
    <div class="rule" v-for="rule in rules">
      <div class="first">{{rule.first}}</div>
      <div class="second" v-for="second in rule.seconds">
        <div class="title">{{second.title}}</div>
        <div class="third flex-box" v-for="third in second.thirds">
          <span>•&nbsp;&nbsp;&nbsp;</span><span>{{third}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'

export default{
  data(){
    return {
      rules: [
        {
          "first": "为了维护内容质量及友善的社区氛围，平台会依据本规范中的条款对用户和用户发布的内容进行管理。"
        },
        {
          "first": "一. 基本原则",
          "seconds": [
            {"title": "1. 规范适用于所有用户。"},
            {"title": "2. 须遵纪守法，对他人保持友善和尊重。不得发表违背法律法规及社会公德的内容，用户需要对自己发表的内容负责，平台有权删除不符合社区规范的内容。"},
            {"title": "3. 用户访问或使用我方产品，即视为同意接受本规范的全部内容。"}
          ]
        },
        {
          "first": "二. 平台可能采取删除违规内容、终止违规用户使用功能等方式，对以下违法、不良信息或存在危害的行为进行处理。",
          "seconds": [
            {
              "title": "1. 违反法律法规：发布违反国家相关法律法规及管理规定的信息，包括但不限于以下几点：",
              "thirds": [
                "反对宪法所确定的基本原则", "危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一", "损害国家荣誉和利益",
                "煽动民族仇恨、民族歧视，破坏民族团结", "侮辱、滥用英烈形象，否定英烈事迹，美化粉饰侵略战争行为的", "破坏国家宗教政策，宣扬邪教和封建迷信",
                "散布谣言，扰乱社会秩序，破坏社会稳定", "宣扬淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪", "煽动非法集会、结社、游行、示威、聚众扰乱社会秩序",
                "诽谤他人，泄露他人隐私，侵害他人合法权益", "含有法律、行政法规禁止的其他内容的信息"
              ]
            },
            {
              "title": "2. 不友善行为，包括但不限于以下几点：",
              "thirds": [
                "人身攻击及辱骂他人。", "针对以下群体发表诅咒、歧视、漠视生命尊严等性质的言论，群体包括：国籍、地域、性别、性别认同、性倾向、种族、疾病、宗教、残障群体等。",
                "对他人进行诅咒、恐吓或威胁。", "针对他人的私德、观点立场、素质、能力等方面的贬低或不尊重。", "讽刺他人，阴阳怪气地表达批评。",
                "对他人使用粗俗用语，并产生了冒犯。"
              ]
            },
            {
              "title": "3. 发布垃圾广告信息：用户以推广曝光为目的，发布影响用户体验、扰乱社区秩序的内容，或进行相关行为，包括但不限于以下几点：",
              "thirds": [
                "多次发布包含售卖产品、提供服务、宣传推广内容的垃圾广告。", "使用严重影响用户体验的违规手段进行恶意营销。"
              ]
            },
            {
              "title": "4. 恶意行为：滥用产品功能，进行影响用户体验，危及平台安全及损害他人权益的行为。包括但不限于以下几点：",
              "thirds": [
                "重复发布干扰正常用户体验的内容。", "发布含有潜在危险的内容，或使用第三方网站伪造跳转链接，如钓鱼网站、木马、病毒网站等。",
                "发布微信、QQ、电话等联系方式。"
              ]
            },
            {
              "title": "5. 色情低俗信息，包括但不限于以下几点：",
              "thirds": [
                "包含自己或他人性经验的细节描述或露骨的感受描述", "涉及色情段子、两性笑话的低俗内容", "带有性暗示、性挑逗等易使人产生性联想",
                "展现血腥、惊悚、残忍等致人身心不适", "炒作绯闻、丑闻、劣迹等", "宣扬低俗、庸俗、媚俗内容"
              ]
            },
            {
              "title": "6. 不实信息，包括但不限于以下几点：",
              "thirds": [
                "可能存在事实性错误或者造谣等内容", "存在事实夸大、伪造虚假经历等误导他人的内容", "伪造身份、冒充他人，通过头像、用户名等个人信息暗示自己具有特定身份，或与特定机构或个人存在关联"
              ]
            },
            {
              "title": "7. 传播封建迷信，包括但不限于以下几点：",
              "thirds": [
                "宣扬鼓励封建迷信等活动，推广算命等理论"
              ]
            },
            {
              "title": "8. 其他危害行为或内容，包括但不限于以下几点：",
              "thirds": [
                "可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好影响未成年人身心健康的", "不当评述自然灾害、重大事故等灾难的",
                "美化、粉饰侵略战争行为的", "法律、行政法规禁止，或可能对网络生态造成不良影响的其他内容。"
              ]
            }
          ]
        },
        {
          "first": "三. 违规行为处理流程",
          "seconds": [
            { "title": "1. 平台通过主动发现和接受用户举报两种方式收集违规行为信息。用户可以向平台反馈涉嫌规范的的行为和用户。违规的信息由平台根据规范直接处理。"},
            { "title": "2. 侵权投诉：用户在平台发布的内容仅表明其个人的立场和观点，并不代表平台的立场和观点。如个人或企业发现平台上存在侵犯自身合法权益的内容，可以向平台进行投诉。为了保证问题能够及时有效地处理，平台将要求投诉人提交真实有效、完整清晰的证明材料，否则投诉将无法受理。"}
          ]
        },
        {
          "first": "四. 违规处罚",
          "seconds": [
            {"title": "当一个用户发布违规内容时，平台将依据相关用户违规情节严重程度，对帐号进行禁言7天、30天直至永久禁言的处罚。并根据违规情节严重程度，采取更多处理方式。"}
          ]
        },
        {
          "first": "五. 其他",
          "seconds": [
            { "title": "1. 平台有权保存用户发表内容时的IP地址，共同营造更加和谐的社区环境。"},
            { "title": "2. 平台有权免费将用户发表的内容用于平台方各种形态的产品和服务上，包括但不限于网站、应用及其他互联网产品。"}
          ]
        }
      ]
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    wxConfigInit(){
      this.$api.get('/shanzhadao/get_wx_js_config_shanzhadao', {url: window.location.href}, res => {
        if(res.code == 200 && res.config){
          // alert('config: ' +JSON.stringify(res.config))
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.config.app_id, // 必填，公众号的唯一标识
            timestamp: res.config.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.config.noncestr, // 必填，生成签名的随机串
            signature: res.config.signature,// 必填，签名
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage'] // 必填，需要使用的JS接口列表
          });

          let share_nickname = this.$store.state.userinfo.nickname
          let share_title = `${share_nickname}给你写了一条留言～`
          let share_desc = '这里有你的故事'
          let share_link = this.$store.state.siteDomain
          let share_img = this.$store.state.userinfo.headimg

          let openid = this.$store.state.userinfo.openid
          let site_code = this.$store.state.siteCode
          let _this = this
          //分享到朋友圈（即将废弃）
          wx.onMenuShareTimeline({
            title: share_title, // 分享标题
            link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: share_img, // 分享图标
            success: function () {
              // 用户点击了分享后执行的回调函数
              _this.$hawutil.reportShare(site_code, openid)
            }
          })
          //分享给朋友（即将废弃）
          wx.onMenuShareAppMessage({
            title: share_title, // 分享标题
            desc: share_desc, // 分享描述
            link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: share_img, // 分享图标
            type: '', // 分享类型,music、video或link，不填默认为link
            dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
            success: function () {
              // 用户点击了分享后执行的回调函数
              _this.$hawutil.reportShare(site_code, openid)
            }
          })

          // //分享给朋友
          // wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
          //   wx.updateAppMessageShareData({
          //     title: share_title, // 分享标题
          //     desc: share_desc, // 分享描述
          //     link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          //     imgUrl: share_img, // 分享图标
          //     success: function () {
          //       // 设置成功
          //       // _this.$hawutil.reportShare(site_code, openid)
          //     }
          //   })
          // });
          //
          // //分享到朋友圈
          // wx.ready(function () {      //需在用户可能点击分享按钮前就先调用
          //   wx.updateTimelineShareData({
          //     title: share_title, // 分享标题
          //     link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          //     imgUrl: share_img, // 分享图标
          //     success: function () {
          //       // 设置成功
          //       // _this.$hawutil.reportShare('wanxin', openid)
          //     }
          //   })
          // });

        }
      })
    }
  },
  mounted(){
    this.wxConfigInit()
  }
}
</script>

<style scoped>
.content-main{
  text-align:left;
  color:#222;
  background-color:#fff;
  min-height:100%;
  padding:20px 10px;
}
.rule{margin-bottom:20px;}
.rule .first{font-size:16px;font-weight:bold;margin-bottom:10px;}
.rule .second{padding:0px 10px;}
.rule .second .title{font-size:15px;margin-bottom:3px;margin-top:5px;}
.rule .third{font-size:14px;padding:0px 10px;margin-bottom:2px;align-items:flex-start;}
</style>
